import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import IconButtonMUI from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import { handleDrawerOpen } from '../../../../domain/features/ui/drawerSlice'

const IconButton = styled(IconButtonMUI)`
  padding: 0;
  padding-right: 10px;
  color: ${({ theme }) => theme.palette.info.main};
  &:disabled {
    cursor: not-allowed;
    pointer-events: auto;
    color: #cccccc !important;
  }
`

const MenuButton = ({ ...props }) => {
  const dispatch = useDispatch()
  return (
    <IconButton
      color="inherit"
      aria-label="open-drawer"
      {...props}
      onClick={() => dispatch(handleDrawerOpen())}
    >
      <MenuIcon fontSize="large" />
    </IconButton>
  )
}

export default MenuButton
